import { useSessionExpiresAt, useUser } from '.'

export const useIsAuthed = () => {
  const u = useUser()
  // const expiresAt = useSessionExpiresAt()
  // const now = Math.floor(new Date().getTime())
  // if (u && expiresAt < now) return null
  return !!u
}
